import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface OtherAssetsInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function OtherAssetsInternalControls({ onBack, setActiveSection, controlsListSection }: OtherAssetsInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Other Assets"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}


